import {apiSlice} from './apiSlice';

// Define a service using a base URL and expected endpoints
export const payerApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getPayers: builder.query({
      query: filters => {
        const qs = Object.keys(filters).reduce((acc, k) => {
          acc.set(k, filters[k]);
          return acc;
        }, new URLSearchParams());
        return `payer/?${qs}`;
      },
      providesTags: ['Payer'],
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {useGetPayersQuery} = payerApi;
